module.exports = __webpack_public_path__ + "img/product_45.71b34d2.webp";